import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface orderDevices{
    orderNumber: string | undefined
    medicalTest: string | undefined
    legacyOrder: number | undefined
}

export const documentDevicesOrder = createSlice({
    name: 'documentDevicesOrder',
    initialState: {
        order: {
            orderNumber: undefined,
            medicalTest: undefined,
            legacyOrder: undefined
        }
    } as { order: orderDevices },
    reducers: {
        setOrderData: (state, action: PayloadAction<orderDevices>) => {
            state.order.orderNumber = action.payload.orderNumber
            state.order.medicalTest = action.payload.medicalTest
            state.order.legacyOrder = action.payload.legacyOrder
        },
        cleanOrderData: (state) => {
            state.order.medicalTest = undefined
            state.order.orderNumber = undefined
        }
    }
})

export const  { setOrderData, cleanOrderData } = documentDevicesOrder.actions
export default documentDevicesOrder.reducer